import { Vue, Component, Ref, Prop, Emit } from 'vue-property-decorator'
import { cloneDeep } from 'lodash'
import { ConfigurationSampleTypeLaboratoryCreateRequest, ConfigurationSampleTypeLaboratoryPatchInBatchRequest, ConfigurationSampleTypeLaboratoryResponse } from '@/modules/configurationModule/detail/local-samples/local-sample-types/services/local-sample-types.dto'
import { initialLocalSampleTypesModalState, LocalSampleTypesModalComboElement, LocalSampleTypesModalState } from '@/modules/configurationModule/detail/local-samples/local-sample-types/components/local-sample-types-modal/local-sample-types-modal.model'
import { commonSampleTypeService } from '@/api/services/common/sample-type/common-sample-type.service'
import { CommonSampleTypeResponse } from '@/api/services/common/sample-type/common-sample-type.dto'
import { Nullable } from '@/shared/types/app.types'

@Component
export default class LocalSampleTypesModal extends Vue {
    @Ref() readonly localSampleTypesModal!: any

    @Prop(String) readonly actionTitle!: string

    @Emit()
    update(localSampleTypePatch: ConfigurationSampleTypeLaboratoryPatchInBatchRequest[]): ConfigurationSampleTypeLaboratoryPatchInBatchRequest[] {
        return localSampleTypePatch
    }

    @Emit()
    create(localSampleTypeCreate: ConfigurationSampleTypeLaboratoryCreateRequest): ConfigurationSampleTypeLaboratoryCreateRequest {
        return localSampleTypeCreate
    }

    state: LocalSampleTypesModalState
    constructor() {
        super()
        this.state = initialLocalSampleTypesModalState()
    }

    get canUpdateCombo(): boolean {
        return !this.state.selectedRow?.id
    }

    get canUpdate(): boolean {
        const hasError: boolean = !!this.errors.count()
        const anyFieldIsDirty = this.$_someFieldIsDirty(this.fields)
        const comboSelectionValid = !!this.state.globalSampleTypes.selected?.id
        return !hasError && anyFieldIsDirty && comboSelectionValid
    }

    async show(selectedRow: Nullable<ConfigurationSampleTypeLaboratoryResponse>): Promise<void> {
        this.state = initialLocalSampleTypesModalState()
        await this._getCommonSampleTypes()
        await this.$validator.reset()
        if (selectedRow) {
            this._setSelectedRow(selectedRow)
            this._setSelectedCombo()
        }
        this._showModal()
    }

    hide(): void { this.localSampleTypesModal.hide() }

    updateRow(selectedRow: Nullable<ConfigurationSampleTypeLaboratoryResponse>): void {
        this._setSelectedRow(selectedRow)
    }

    spreadEvent(): void {
        if (this.state.selectedRow?.id) {
            const patchRow: ConfigurationSampleTypeLaboratoryPatchInBatchRequest = {
                id: this.state.selectedRow.id,
                active: this.state.selectedRow.active,
                defaultDaysBeforeDisposal: this.state.selectedRow.defaultDaysBeforeDisposal,
                processingRequired: this.state.selectedRow.processingRequired
            }
            this.update([patchRow])
            return
        }
        const postRow: ConfigurationSampleTypeLaboratoryCreateRequest = {
            active: this.state.selectedRow.active,
            defaultDaysBeforeDisposal: this.state.selectedRow.defaultDaysBeforeDisposal,
            processingRequired: this.state.selectedRow.processingRequired,
            sampleTypeId: this.state.globalSampleTypes.selected?.id as number
        }
        this.create(postRow)
    }

    private _setSelectedRow(selectedRow: Nullable<ConfigurationSampleTypeLaboratoryResponse>): void {
        const rowToSend = cloneDeep(selectedRow)
        this.state = {
            ...this.state,
            selectedRow: rowToSend as ConfigurationSampleTypeLaboratoryResponse
        }
    }

    private async _getCommonSampleTypes(): Promise<void> {
        const [err, response] = await this.$_toCall(commonSampleTypeService.getSampleTypes())
        if (err) {
            this.state.globalSampleTypes.list = []
            return
        }
        this.state.globalSampleTypes.list = response?.map((sampleType: CommonSampleTypeResponse) => {
            return {
                id: sampleType.id,
                text: sampleType.description
            }
        })
    }

    private _setSelectedCombo(): void {
        const foundElementInList = this.state.globalSampleTypes.list.find((itemList: LocalSampleTypesModalComboElement) => itemList.id === this.state.selectedRow.sampleType.id)
        if (foundElementInList) {
            this.state.globalSampleTypes.selected = foundElementInList
        }
    }

    private _showModal(): void {
        this.localSampleTypesModal.show()
    }
}
